import { BS_EVENTS } from '../lib/bootstrap-events';

const navbarFlyout = document.getElementById('navbarFlyout'),
	childFlyouts = document.querySelectorAll('#navbarFlyout, .flyout-menu'),
	backLinks = navbarFlyout.querySelectorAll('.back-link'),
	searchForm = navbarFlyout.querySelector('.search-form'),
	closeButtons = navbarFlyout.querySelectorAll('.close-button'),
	currentPage = navbarFlyout.querySelector('.current_page_item');

const isDevice = window.matchMedia('(max-width: 768px)');


const handleNavbarClassAdditions = (navbarElement, isInit = false) => {
	if(navbarElement.classList.contains('level-1') || navbarElement.id == 'navbarFlyout') {
		return;
	} else if (navbarElement.classList.contains('level-2')) {
		navbarFlyout.classList.add('show-level-2');
	} else if (navbarElement.classList.contains('level-3')) {
		navbarFlyout.classList.add('show-level-3');
	} else if (navbarElement.classList.contains('level-4')) {
		navbarFlyout.classList.add('show-level-4');
	}
	
	// add timeout to allow animation to run with adding "display block"
	setTimeout(() => {
		// shift nav
		if(navbarElement.classList.contains('level-4')) {
			navbarFlyout.classList.add("shift-nav");
		} else {
			if(!isInit) {
				navbarFlyout.classList.remove("shift-nav");
			}
		}
		
		// force add show
		navbarElement.classList.add('show');				
	}, 10);
}

export const watchNavigation = () => {
	// setup menus to defualt to current page
	if(currentPage) {
		let parent = currentPage.parentElement;
		while(parent != null) {
			if(parent.classList.contains('flyout-menu') && !parent.classList.contains('level-1')) {
				new window.bootstrap.Collapse(parent, {
					toggle: false
				}).show();

				handleNavbarClassAdditions(parent, true);
			}
			parent = parent.parentElement;
		}
	}


	navbarFlyout.addEventListener(BS_EVENTS.COLLAPSE.SHOW, (event) => {
		document.body.classList.add("show-flyout");
	});
	navbarFlyout.addEventListener(BS_EVENTS.COLLAPSE.HIDE, (event) => {
		document.body.classList.remove("show-flyout");
	});

	searchForm.addEventListener(BS_EVENTS.COLLAPSE.SHOW, (event) => {
		// prevent bubbling up to parent flyouts
		event.stopPropagation();
	});

	childFlyouts.forEach((childFlyout) => {

		childFlyout.addEventListener(BS_EVENTS.COLLAPSE.SHOW, (event) => {
			// prevent bubbling up to parent flyouts
			event.stopPropagation();

			handleNavbarClassAdditions(childFlyout);
		});

		childFlyout.addEventListener(BS_EVENTS.COLLAPSE.HIDE, (event) => {
			// prevent bubbling up to parent flyouts
			event.stopPropagation();

			if(childFlyout.classList.contains('level-1')) {
				navbarFlyout.classList.remove('show-level-1');
			} else if (childFlyout.classList.contains('level-2')) {
				navbarFlyout.classList.remove('show-level-2');
			} else if (childFlyout.classList.contains('level-3')) {
				navbarFlyout.classList.remove('show-level-3');
			} else if (childFlyout.classList.contains('level-4')) {
				navbarFlyout.classList.remove('show-level-4');
			}
			
			// shift nav
			if(childFlyout.classList.contains('level-4')) {
				navbarFlyout.classList.remove("shift-nav");
			}

			// hide child menus
			childFlyout.querySelectorAll('.flyout-menu').forEach((descendentFlyout) => {
				new window.bootstrap.Collapse(descendentFlyout, {
					toggle: false
				}).hide();
			});
		});
	});


	//handle close 
	closeButtons.forEach((closeButton) => {
		closeButton.addEventListener('click', (event) => {
			new window.bootstrap.Collapse(document.querySelector(closeButton.dataset.target), {
				toggle: false
			}).hide();
		});
	});

	// handle back links
	backLinks.forEach((backLink) => {
		backLink.addEventListener('click', (event) => {
			let target = document.querySelector(backLink.dataset.target);
			target.querySelectorAll('.flyout-menu').forEach((descendentFlyout) => {
				console.log("hide child menu", descendentFlyout);
				new window.bootstrap.Collapse(descendentFlyout, {
					toggle: false
				}).hide();
			});
			if(isDevice.matches) {
				new window.bootstrap.Collapse(target, {
					toggle: false
				}).hide();
			}
		});
	});
};